import Vue from 'vue';
import store from './store';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

Vue.component('app-datepicker-filter', require('./components/admin/AppDatepickerFilter').default);
Vue.component('analytics', require('./components/admin/Analytics').default);
Vue.component('financial-report', require('./components/admin/FinancialReport').default);
Vue.component('transactions', require('./components/admin/Transactions').default);
Vue.component('reports', require('./components/admin/Reports').default);
Vue.component('alfa-reports', require('./components/admin/AlfaReports').default);
Vue.component('merchant-reports', require('./components/admin/MerchantReports').default);
Vue.component('transaction', require('./components/admin/Transaction').default);
Vue.component('payment-logs', require('./components/admin/TransactionPaymentLogs').default);
Vue.component('settings', require('./components/admin/settings/Settings').default);
Vue.component('dynamic-link', require('./components/admin/link/DynamicLink').default);
Vue.component('rule', require('./components/Rule').default);
Vue.component('refund-modal', require('./components/admin/RefundModal').default);
Vue.component('payment-board', require('./components/admin/PaymentBoard').default);

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const app = new Vue({
    el: '#app',
    store
});

window.$ = window.jQuery = require("jquery");

const loginAuthApp = document.querySelector('#login-auth-app');
if(loginAuthApp) {
    const loginAuthAppInstance = new Vue({
        el: '#login-auth-app',
        data: {
            authBtnDisabled: false,
            authEmail: null,
            authPassword: null,
            authEye: false
        },
        computed: {
            authEyeType() {
                return this.authEye ? 'text' : 'password';
            }
        },
        methods: {
            toggleAuthBtnDisabled(bool) {
                this.authBtnDisabled = bool
            },
            submitLogin() {
                document.getElementById("auth-login-form").submit();
                this.toggleAuthBtnDisabled(true);
                setTimeout(() => {
                    this.toggleAuthBtnDisabled(false);
                }, 2000);
            },
            toggleAuthEye() {
                this.authEye = !this.authEye
            }
        }
    });
}
